module.exports = __webpack_public_path__ + "images/fa-cm2024-bg-pricing-mobile.webp";